import { EditIcon2 } from "@/styles/icons/EditIcon2";
import { Flex, Text, Button } from "@chakra-ui/react";
import { useState } from "react";
import RenameCreditCard from "../renomear-cartao";

interface CreditCardNameProps {
  name: string;
}

export function CreditCardName({
    name,
}: CreditCardNameProps) {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <>
        <RenameCreditCard
            isOpen={isEditing}
            onClose={() => setIsEditing(false)}
        />
        <Flex
            maxW="400px"
            w="100%"
            border="1px solid #E6E9F0"
            borderRadius="1rem"
            padding="1rem"
            h="55px"
            direction="column"
            justifyContent="center"
        >
            <Flex 
                justify="space-between" 
                align="center" 
                w="100%"
                h="100%"

            >
                <Flex 
                    align="center" 
                    gap={2}
                    w="100%"
                    h="100%"
                >
                    <Text>
                        {name}
                    </Text>
                    <Button
                        variant="ghost"
                        size="sm"
                        p={0}
                        onClick={() => setIsEditing(true)}
                    >
                        <EditIcon2 size={16} />
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    </>
  );
}